import React, { PureComponent } from 'react';
import './LoadingTooltip.css';

export default class LoadingTooltip extends PureComponent {
  getContainerStyle = () => {
    const { appApi } = this.props;
    const { width, height } = appApi.tool.getToolSpecification(
      'loadingTooltip'
    );
    return {
      width: width,
      height: height,
    };
  };
  render() {
    const { appApi } = this.props;
    const { label, thumbnailUrl, labelSize } = appApi.tool.getToolSpecification(
      'loadingTooltip'
    );
    const style = this.getContainerStyle();

    return (
      <div id="loadingTooltipContainer" style={style}>
        <img src={thumbnailUrl} alt="" style={{ height: style.height }} />
        <p style={{ fontSize: labelSize }}>{label}</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LoadingTooltip/index.js